import i18n from "@/i18n";
const formatter = {
    cellFormatterMulti: function (cell, formatterParams, onRendered) {
        //  console.log('cellformattermulti');
        if (typeof(formatterParams) == "undefined")formatterParams={};
        var value = cell.getValue();

        $.each(formatterParams.functions, function(ndx, val){
            if (typeof(val) ==="function"){
                value = val(cell, formatterParams, onRendered);
            } 
            else if (typeof(formatter[val])==="function"){
                value = formatter[val](cell, formatterParams, onRendered);
            }
        });

        return value;
    },
    // expected to be used with checkboxFlipper in cellClick option
    checkBox: function (cell, formatterParams, onRendered) {
        formatter.addEditedBorder(cell, formatterParams, onRendered);

        return cell.getValue() == true
            ? "<input type=\"checkbox\" checked tabindex=\"0\" />"
            : "<input type=\"checkbox\" tabindex=\"0\" />";
    },
    addEditedBorder: function (cell, formatterParams, onRendered) {
        if (typeof(cell._cell) == "undefined") 
            return cell.getValue();

        var oldValue = cell._cell.oldValue;

        if (oldValue != null && oldValue !== cell.getValue()) {
            $(cell.getElement()).addClass("redBorder");
        }
        return cell.getValue();
    },
    PosNegHighlight: function (cell, formatterParams, onRendered) {
        var cellClass = "";
        var value = cell.getValue();

        if (formatterParams.PosNegDirection == "Asc"){
            if (value < 0){ cellClass = "CPOS"; }
            if (value > 0){ cellClass = "CNEG"; }
        } else {
            if (value > 0){ cellClass = "CPOS"; }
            if (value < 0){ cellClass = "CNEG"; }
        }

        if (cellClass != ""){
            $(cell.getElement()).addClass(cellClass);
        }
        return value;
    }, 
    pickerCell(cell, formatterParams, onRendered) {
        var row = cell.getRow();
        var oldValue =  (typeof(cell._cell) == "undefined") ? null : cell._cell.oldValue;
  
        if (oldValue != null && oldValue != cell.getValue()) {
            $(cell.getElement()).addClass("redBorder");
        }
        var cellValue = cell.getValue();
        if (cellValue === null || cellValue === undefined) {
            cellValue = "";
        }
        //todo: these styles should not be inline.  put them in a stylesheet somewhere.
        return  "<span style='vertical-align:top;border-radius:3px'><span class='icon-edit-24' /></span><span style='vertical-align:top;'>&nbsp;&nbsp;" +
          cellValue +
          "</span>";
        
    },
    deptCellFormatter(cell) {
        const oldValue =  (typeof(cell._cell) == "undefined") ? null : cell._cell.oldValue;
  
        if (oldValue != null && oldValue != cell.getValue()) {
            $(cell.getElement()).addClass("redBorder");
        }

        let cellValue = cell.getValue();
        if (cellValue === null || cellValue === undefined) {
            cellValue = "";
        }
        
        if (cellValue && cellValue.length > 0){
            let newCellValues = [];
            cellValue.forEach(item => {
                const binaryValue = item.isManagementLabor.toString() + item.isExpense.toString() + item.isLabor.toString() + item.isRevenue.toString();
                newCellValues.push(item.tag + parseInt(binaryValue, 2) + " ");
            });
            const stringValue = newCellValues.join(" ");

            return  "<span style='vertical-align:top;border-radius:3px'><span class='icon-edit-24' /></span><span style='vertical-align:top;'>&nbsp;&nbsp;" +
            stringValue +
            "</span>";
            
        } else return "<span style='vertical-align:top;border-radius:3px'><span class='icon-edit-24' /></span><span style='vertical-align:top;'>&nbsp;&nbsp;" + cellValue + "</span>";;
    },
    boldTotalRows(cell,formatterParams, onRendered){
        if(formatterParams.isTotal){
            $(cell.getElement()).addClass("Bold");
        }
        return cell.getValue();
    },
    disabledCell(cell, formatterParams, onRendered) {
        if (
            cell._cell != undefined &&
          cell._cell.oldValue != null &&
          cell._cell.oldValue != cell.getValue()
        ) {
            $(cell.getElement()).addClass("redBorder");
        }
  
        var cellValue = cell.getValue();
        if (cellValue === null || cellValue === undefined) {
            cellValue = "";
        }
        return "<span>" + cellValue + "</span>";
    },
    deleteIcon(cell, formatterParams, onRendered) {
        return "<span class='icon-trash-24' />";
    },
    definedIcons(cell, formatterParams, onRendered) {
        // console.log("in definedIcons()");  
        // console.log(formatterParams.icons);
        var html = "";
        formatterParams.icons.forEach(o => {         
            html += "<span class='icon-" + o + " icon-table' /> ";                         
        });
  
        return html;
    },
    refreshIcon(cell, formatterParams, onRendered) {
        var row = cell.getRow();
        if (row._row.data.guid !== "00000000-0000-0000-0000-000000000000") {
            return "<span class='icon-Refresh_24' style='font-size:1.0em !important;' alt='reset password'/>";
        } else {
            return "<span></span>";
        }
    },
    routerHyperLink(cell, formatterParams, onRendered) {
        var cellValue = cell.getValue();
        return "<a style='cursor:pointer'>" + cellValue + "</a>";
    },
    hyperLink(cell, formatterParams, onRendered) {
        var cellValue = cell.getValue();
        if (cellValue === null || cellValue === undefined) {
            cellValue = "";
        }
  
        var html = "<a href='" + formatterParams.linkHref + "'";
        
        if(formatterParams.linkTarget !="") {
            html += " target='" + formatterParams.linkTarget + "'";
        }
        
        html += ">" + cellValue + "</a>";
        return html;
    },
    //========= NUMBER FORMATTERS============
    currencyFormat(cell, formatterParams, onRendered)  {        
        return i18n.n(cell.getValue(), "currency").replace("$","");
    },
    currencyFormatAbsoluteValue(cell, formatterParams, onRendered) {
        var absAmount = Math.abs(cell.getValue());
        return i18n.n(absAmount, "currency").replace("$","");
    },
    commaSeparator(cell, formatterParams, onRendered) {
        var value = cell.getValue();
        return value == null ? value : value.toLocaleString();
    },
    decimalFormat(cell, formatterParams, onRendered)  {        
        var value = cell.getValue();
        if (value == null) {
            return value;
        } else if (typeof value === "string") {
            return parseFloat(value).toFixed(formatterParams.decimalPlaces);
        } else {
            return value.toFixed(formatterParams.decimalPlaces);
        }
    },
    periodFormat(cell, formatterParams, onRendered) {
        var number = cell.getValue();
        if(number.length == 6)
        {
            return number.toString().substring(0,4) + "-" + number.toString().substring(4,6);
        }
    },
    
    renderChildComponents: function (cell, formatterParams, onRendered){

        /*  if (typeof(formatterParams.components[0]['props'].click)  == 'string' && !formatterParams.components[0]['props'].click.includes('(') ) {
            formatterParams.components[0]['props'].click = formatterParams.components[0]['props'].click + '(event, cell, row)';
        }*/
        
        var instance = new formatterParams.components[0]["instance"]({
            propsData: formatterParams.components[0]["props"]
        }); 
        instance.cell = cell;
        instance.row = cell.getRow();
        instance.$mount();
        //formatterParams.components[0].$mount(cell.getElement());
        return instance.$el;
    }
    
};

const cellClick = {
    // expected to be used with checkBoxFormatter in the formatter option
    checkboxFlipper (e, cell) {
        if (e.srcElement.tagName == "INPUT") {
            cell.setValue(!cell.getValue());
        }
    },

    // expected to be used on cell click when hitting the delete button on a row
    setRowDeleteCondition (e, cell) {
        var row = cell.getRow();
        if (
            row._row.data.markedForDeletion == undefined ||
      row._row.data.markedForDeletion == null
        ) {
            row._row.data.markedForDeletion = true;
            row.getElement().classList.add("tabulator-selected");
        } else {
            row._row.data.markedForDeletion = !row._row.data.markedForDeletion;
            row.getElement().classList.toggle("tabulator-selected");
        }
    }
};

const mutator = {
    // expected to be used with the mutator to trim info coming into and out of your table.
    trimCellMutator (value, data, type, params, component) {
        var formatedValue = value;
        if (value != undefined && value != null) {
            formatedValue = formatedValue.trim();
        }
        return formatedValue;
    },
    subtract(value, data, type, params, component){
        var returnVal = data[params.minuend] - data[params.subtrahend];
        if(params.rounding == "undefined" || params.rounding == null || params.rounding == -1){
            return parseFloat(returnVal);
        }
        else{
            return parseFloat(returnVal.toFixed(params.rounding));
        } 
    },
    divPercent(value, data, type, params, component){
        var quotient = data[params.dividend] == 0 ? 0 : data[params.divisor] / data[params.dividend] * 100;
        if(params.rounding == "undefined" || params.rounding == null || params.rounding == -1){
            return parseFloat(quotient);
        }
        else{
            return parseFloat(quotient.toFixed(params.rounding));
        }
    },
    percentDiff(value, data, type, params, component){
        if(parseFloat(data[params.compValue]).toFixed(2) == 0)
            return 0;
        var returnVal = (data[params.dataValue] - data[params.compValue]) / data[params.compValue] * 100;
        if(data[params.compValue] < 0)
            returnVal = returnVal * -1;
        if(params.rounding == "undefined" || params.rounding == null || params.rounding == -1)
            return parseFloat(returnVal);
        else
            return parseFloat(returnVal.toFixed(params.rounding));
    }
};

export {
    formatter,
    cellClick,
    mutator
};
